// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 03/09/2025
const RangeLoanProposalActionTypes = {
	/************* GET RANGE LOAN PROPOSAL LIST START ********************/
	GET_RANGE_LOAN_PROPOSAL_LIST_START: 'get_range_loan_proposal_list_start',
	GET_RANGE_LOAN_PROPOSAL_LIST_SUCCESS: 'get_range_loan_proposal_list_success',
	GET_RANGE_LOAN_PROPOSAL_LIST_FAILURE: 'get_range_loan_proposal_list_failure',
	GET_RANGE_LOAN_PROPOSAL_LIST_RESPONSE_RESET: 'get_range_loan_proposal_list_response_reset',
	GET_RANGE_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED: 'get_range_loan_proposal_list_response_changed',
	/************* GET RANGE LOAN PROPOSAL LIST END ********************/

	/************* GET RANGE LOAN PROPOSAL CENTER LIST START ********************/
	GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_START: 'get_range_loan_proposal_center_list_start',
	GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_SUCCESS: 'get_range_loan_proposal_center_list_success',
	GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_FAILURE: 'get_range_loan_proposal_center_list_failure',
	GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_RESPONSE_RESET:
		'get_range_loan_proposal_center_list_response_reset',
	GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_RESPONSE_CHANGED:
		'get_range_loan_proposal_center_list_response_changed',
	/************* GET RANGE LOAN PROPOSAL CENTER LIST END ********************/

	/************* GET CENTER MEMBER LIST START ********************/
	GET_CENTER_MEMBER_LIST_START: 'get_center_member_list_start',
	GET_CENTER_MEMBER_LIST_SUCCESS: 'get_center_member_list_success',
	GET_CENTER_MEMBER_LIST_FAILURE: 'get_center_member_list_failure',
	GET_CENTER_MEMBER_LIST_RESPONSE_RESET: 'get_center_member_list_response_reset',
	GET_CENTER_MEMBER_LIST_RESPONSE_CHANGED: 'get_center_member_list_response_changed',
	/************* GET CENTER MEMBER LIST END ********************/

	/************* GET RANGE PRODUCT LIST START ********************/
	GET_RANGE_PRODUCT_LIST_START: 'get_range_product_list_start',
	GET_RANGE_PRODUCT_LIST_SUCCESS: 'get_range_product_list_success',
	GET_RANGE_PRODUCT_LIST_FAILURE: 'get_range_product_list_failure',
	GET_RANGE_PRODUCT_LIST_RESPONSE_RESET: 'get_range_product_list_response_reset',
	GET_RANGE_PRODUCT_LIST_RESPONSE_CHANGED: 'get_range_product_list_response_changed',
	/************* GET RANGE PRODUCT LIST END ********************/

	/************* ADD RANGE LOAN PROPOSAL START ********************/
	ADD_RANGE_LOAN_PROPOSAL_START: 'add_range_loan_proposal_start',
	ADD_RANGE_LOAN_PROPOSAL_SUCCESS: 'add_range_loan_proposal_success',
	ADD_RANGE_LOAN_PROPOSAL_FAILURE: 'add_range_loan_proposal_failure',
	ADD_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'add_range_loan_proposal_response_reset',
	ADD_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'add_range_loan_proposal_response_changed',
	/************* ADD RANGE LOAN PROPOSAL END ********************/

	/************* UPDATE RANGE LOAN PROPOSAL START ********************/
	UPDATE_RANGE_LOAN_PROPOSAL_START: 'update_range_loan_proposal_start',
	UPDATE_RANGE_LOAN_PROPOSAL_SUCCESS: 'update_range_loan_proposal_success',
	UPDATE_RANGE_LOAN_PROPOSAL_FAILURE: 'update_range_loan_proposal_failure',
	UPDATE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'update_range_loan_proposal_response_reset',
	UPDATE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'update_range_loan_proposal_response_changed',
	/************* UPDATE RANGE LOAN PROPOSAL END ********************/

	/************* GET CENTER MEMBER LEAD LIST START ********************/
	GET_CENTER_MEMBER_LEAD_LIST_START: 'get_center_member_Lead_list_start',
	GET_CENTER_MEMBER_LEAD_LIST_SUCCESS: 'get_center_member_Lead_list_success',
	GET_CENTER_MEMBER_LEAD_LIST_FAILURE: 'get_center_member_Lead_list_failure',
	GET_CENTER_MEMBER_LEAD_LIST_RESPONSE_RESET: 'get_center_member_Lead_list_response_reset',
	GET_CENTER_MEMBER_LEAD_LIST_RESPONSE_CHANGED: 'get_center_member_Lead_list_response_changed',
	/************* GET CENTER MEMBER LEAD LIST END ********************/

	/************* GET PARTICULAR LOAN INDEX DETAILS START ********************/
	GET_PARTICULAR_LOAN_INDEX_DETAILS_START: 'get_particular_loan_index_details_start',
	GET_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS: 'get_particular_loan_index_details_success',
	GET_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE: 'get_particular_loan_index_details_failure',
	GET_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_RESET:
		'get_particular_loan_index_details_response_reset',
	GET_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
		'get_particular_loan_index_details_response_changed',
	/************* GET PARTICULAR LOAN INDEX DETAILS END ********************/

	/************* APPROVE RANGE LOAN PROPOSAL START ********************/
	APPROVE_RANGE_LOAN_PROPOSAL_START: 'approve_range_loan_proposal_start',
	APPROVE_RANGE_LOAN_PROPOSAL_SUCCESS: 'approve_range_loan_proposal_success',
	APPROVE_RANGE_LOAN_PROPOSAL_FAILURE: 'approve_range_loan_proposal_failure',
	APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'approve_range_loan_proposal_response_reset',
	APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'approve_range_loan_proposal_response_changed',
	/************* APPROVE RANGE LOAN PROPOSAL END ********************/

	/************* REVERT APPROVED RANGE LOAN PROPOSAL START ********************/
	REVERT_APPROVED_RANGE_LOAN_PROPOSAL_START: 'revert_approved_range_loan_proposal_start',
	REVERT_APPROVED_RANGE_LOAN_PROPOSAL_SUCCESS: 'revert_approved_range_loan_proposal_success',
	REVERT_APPROVED_RANGE_LOAN_PROPOSAL_FAILURE: 'revert_approved_range_loan_proposal_failure',
	REVERT_APPROVED_RANGE_LOAN_PROPOSAL_RESPONSE_RESET:
		'revert_approved_range_loan_proposal_response_reset',
	REVERT_APPROVED_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'revert_approved_range_loan_proposal_response_changed',
	/************* REVERT APPROVED RANGE LOAN PROPOSAL END ********************/

	/************* REJECT RANGE LOAN PROPOSAL START ********************/
	REJECT_RANGE_LOAN_PROPOSAL_START: 'reject_range_loan_proposal_start',
	REJECT_RANGE_LOAN_PROPOSAL_SUCCESS: 'reject_range_loan_proposal_success',
	REJECT_RANGE_LOAN_PROPOSAL_FAILURE: 'reject_range_loan_proposal_failure',
	REJECT_RANGE_LOAN_PROPOSAL_RESPONSE_RESET: 'reject_range_loan_proposal_response_reset',
	REJECT_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED: 'reject_range_loan_proposal_response_changed',
	/************* REJECT RANGE LOAN PROPOSAL END ********************/
};
export default RangeLoanProposalActionTypes;
